import { ThreeDots } from "react-loader-spinner";

type PageLoaderProps = {
  message?: string;
};
export const PageLoader = ({ message }: PageLoaderProps) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <ThreeDots
        visible={true}
        height="60"
        width="60"
        color="#00BFFF"
        radius="9"
        ariaLabel="signing-out-loading"
      />
      <p className="text-muted-foreground mt-4">{message || "Loading..."}</p>
    </div>
  );
};
